import React from 'react';
import { Icons } from '../../Icons';
export const blankIcon = React.createElement(Icons, { iconName: "", className: "dropdown-option" });
export const chevronIcon = React.createElement(Icons, { iconName: "ic-ui-chevron-down", className: "dropdown-option" });
export const tickIcon = React.createElement(Icons, { iconName: "ic-ui-tick-01", className: "dropdown-option" });
//# sourceMappingURL=icons.js.map